import { ProcessedUserSectionItem, SidebarMenuItemProps } from '../../../types';
import { SidebarMenu } from '../SidebarMenu';
import { useIsActiveLink } from '../useIsActiveLink';

import { SidebarItem } from './SidebarItem';

const SETTINGS_LINK = '/user_section';

export const SidebarUserSectionItem = ({
  item,
}: SidebarMenuItemProps<ProcessedUserSectionItem['type']>) => {
  const { title, children } = item;

  const isActiveItem = useIsActiveLink(SETTINGS_LINK);

  return (
    <>
      <SidebarMenu menuLabel={title} items={children} />
      <SidebarItem
        href={SETTINGS_LINK}
        color="original.brand.primary"
        iconName="sliders_outline"
        aqaClass={`aqa_${title}`}
        title="Настроить блок"
        isActive={isActiveItem}
        showIcon
      />
    </>
  );
};
